import * as DATE from 'date-fns';
import { de, enUS, es, fr, frCA, it, ja, ko, pt, zhCN } from 'date-fns/locale';
import { constant, identity, pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import { convertToTimezone } from './convert-to-timezone';
import { isTimezoneValid } from './is-timezone-valid';
var locales = {
  de: de,
  en: enUS,
  es: es,
  fr: fr,
  'fr-CA': frCA,
  it: it,
  ja: ja,
  ko: ko,
  pt: pt,
  zh: zhCN
};
export var formatAbsolute = function formatAbsolute(end) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$showTimeWithDate = _ref.showTimeWithDate,
      showTimeWithDate = _ref$showTimeWithDate === void 0 ? true : _ref$showTimeWithDate,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? undefined : _ref$timezone,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? 'en' : _ref$lang;

  return function (start) {
    var locale = locales[lang !== null && lang !== void 0 ? lang : 'en'];
    if (!DATE.isValid(start) || !DATE.isValid(end)) return '';
    return pipe(timezone, isTimezoneValid, O.match(constant(identity), convertToTimezone), function (dateConversion) {
      return {
        end: dateConversion(end),
        start: dateConversion(start)
      };
    }, function (_ref2) {
      var end = _ref2.end,
          start = _ref2.start;
      var startTime = DATE.format(start, 'p', {
        locale: locale
      });
      var numOfDays = Math.abs(DATE.differenceInCalendarDays(end, start));
      return DATE.isSameDay(start, end) ? startTime : numOfDays === 1 && start < end && lang === 'en' ? 'Yesterday' : numOfDays < 7 ? DATE.format(start, 'E' + (showTimeWithDate ? ' p' : ''), {
        locale: locale
      }) : DATE.isSameYear(start, end) ? DATE.format(start, 'MMM do' + (showTimeWithDate ? ' p' : ''), {
        locale: locale
      }) : DATE.format(start, 'PP' + (showTimeWithDate ? ' p' : ''), {
        locale: locale
      });
    });
  };
};